document.addEventListener("DOMContentLoaded", () => {
  const colorRadios = document.querySelectorAll(
    '.color-radio input[type="radio"]'
  );
  const triggerLabelClick = (input) => {
    input.checked = true;
    const label = document.querySelector(`label[for="${input.id}"]`);
    if (label) {
      label.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    }
  };
  colorRadios.forEach((input) => {
    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        triggerLabelClick(input);
      }
    });
    input.addEventListener("click", () => triggerLabelClick(input));
  });
  setTimeout(() => {
    document
      .querySelectorAll(".color-radio label[tabindex]")
      .forEach((label) => {
        label.removeAttribute("tabindex");
      });
  }, 500);
});
